module.exports = __webpack_public_path__ + "static/img/xi_14.49f5865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_14.jpg
// module id = /X3d
// module chunks = 1